<template>
  <div class="container">
    <!-- 地址 -->
    <my-address :common="common"></my-address>
    <!-- 耗材详情 -->
    <section class="mess_box">
      <section class="mess_top">
        <img class="mess_top_left" :src="tbOfficeMaterial.imgUrl">
        <section class="mess_top_right">
          <h2>{{tbOfficeMaterial.name}}</h2>
          <span :class="['label',tbOfficeMaterial.serviceType==0?'':'more_time']">{{tbOfficeMaterial.serviceType | serviceType}}</span>
          <p class="price">￥{{tbOfficeMaterial.price | priceFormat}}</p>
        </section>
      </section>
      <section class="buy_num">
        <span class="buy_num_left">购买数量</span>
        <section class="buy_num_right">
          <span class="reduce" @click="reduce"><img src="../../assets/images/btn_reduce.png"></span>
          <input type="number" v-model.number="num" @input="inputV">
          <span class="add" @click="add"><img src="../../assets/images/btn_add.png"></span>
        </section>
      </section>
    </section>
    <!-- 商品金额 -->
    <section class="price_box">
      <span class="price_left">商品金额</span>
      <span class="price_right">￥{{tbOfficeMaterial.price*num | priceFormat}}</span>
    </section>
    <!-- 底部 -->
    <footer class="submit_bottom">
      <div class="submitLeft">
        <span class="submitSumText">合计:</span>
        <span class="submitNum">¥{{tbOfficeMaterial.price*num | priceFormat}}</span>
      </div>
      <!-- 支持线下支付 this.tbOfficeMaterial.isOfflinePay == 1 -->
      <span class="submit_btn submit_btn_primary" v-if="this.tbOfficeMaterial.isOfflinePay == 1" @click="confirmPay(1)">线下支付</span>
      <span class="submit_btn" @click="confirmPay">在线支付</span>
    </footer>
  </div>
</template>

<script>
import {getOfficeMaterialById,saveOfficeMaterialOrder } from '../../utils/api';
import util from '../../utils/util';
import MyAddress from './components/myAddress'
import { mapState } from 'vuex';
import ping from "../../utils/pingpay.js";
export default {
  name: 'officeConfirmOrder',
  components: {
    MyAddress
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data () {
    return {
      num:1,
      tbOfficeMaterial:{},
      orderNo:'',
      canClick:true,
      kcQuantity:''//库存数量
    }
  },
  created () {
    this.getOfficeMaterialById()
  },
  filters: {
    serviceType(val){
      if(val == '0'){
        return '一次性送货'
      }else{
        return '多次送货服务'
      }
    }
  },
  methods: {
    getOfficeMaterialById(){
      util.showLoading()
      getOfficeMaterialById({materialId:this.$route.query.id}).then(res=>{
        console.log(res)
        this.showPage = true
        util.hideLoading()
        if(res.res.code === 10000 && res.body && res.body.tbOfficeMaterialOutput){
          this.tbOfficeMaterial = res.body.tbOfficeMaterialOutput.tbOfficeMaterial || {};
          if(this.tbOfficeMaterial.minPurchase){
            this.num = this.tbOfficeMaterial.minPurchase
          }
          let sold = this.tbOfficeMaterial.sold || 0;
          this.kcQuantity = this.tbOfficeMaterial.stock - sold
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    add(){
      if(this.tbOfficeMaterial.maxPurchase >this.kcQuantity){
        if(this.num == this.kcQuantity){
          util.showToast('已达到库存最大数量')
          return;
        }
      }else{
        if(this.num == this.tbOfficeMaterial.maxPurchase){
          util.showToast('已达到最大可购买数量')
          return;
        }
      }
      this.num = this.num+1
    },
    reduce(){
      if(this.num == this.tbOfficeMaterial.minPurchase){
        util.showToast('不能低于最低购买数量')
        return;
      }
      this.num = this.num-1
    },
    inputV(){
      if(this.tbOfficeMaterial.maxPurchase >this.kcQuantity){
        if(this.num > this.kcQuantity){
          util.showToast('已达到库存最大数量')
          this.num = this.kcQuantity
        }
      }else{
        if(this.num > this.tbOfficeMaterial.maxPurchase){
          util.showToast('已达到最大可购买数量')
          this.num = this.tbOfficeMaterial.maxPurchase
        }
      }
      if(this.num < this.tbOfficeMaterial.minPurchase){
        util.showToast('不能低于最低购买数量')
        this.num = this.tbOfficeMaterial.minPurchase
      }
    },
    confirmPay(type){
      if(!this.canClick){return false;}
      this.canClick = false;
      // 生成订单
      let params = {
        materialId:this.$route.query.id,
        orderNum:this.num,
        phone:this.common.userInfo.phone || this.common.userInfo.account,
        payAmount:this.tbOfficeMaterial.price*this.num
      }
      saveOfficeMaterialOrder(params).then(res=>{
        console.log(res)
        this.canClick = true;
        if(res.res && res.res.code === 10000 && res.body){
          this.orderNo = res.body.orderNo
          if(type == '1'){
            this.goResult('6');
          }else{
            this.goResult();
          }
        }
      })
    },
    goResult(payType) {
      let that = this;
      let params = {
        orderNo: this.orderNo,
        repairNo: "", // "报修单号",
        bussinessType:"6",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode:"",
        // payType: payType, // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"6.线下支付
        channel: "wx_pub" // 渠道名
      };
      if(payType == '6'){
        params.payType = payType
      }
      ping(params,'',() => {
          that.$router.replace(`/myOrder?come=office`);
        },
        () => {
          that.$router.replace(`/myOrder?come=office`);
        },
        () => {
          that.$router.replace(`/myOrder?come=office`);
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  background:#eee;
}
// 耗材详情
.mess_box{
  background:#fff;
  .mess_top{
    padding:28px;
    .borderB();
    .flex();
    .mess_top_left{
      display: block;
      width:240px;
      height:180px;
      margin-right:28px;
    }
    .mess_top_right{
      flex:1;
      h2{
        height:40px;
        font-size:28px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:40px;
        .textOver(100%);
        margin-bottom:20px;
      }
      .label{
        display: inline-block;
        margin-bottom:40px;
        padding:0 6px;
        height:36px;
        background:rgba(255,240,225,1);
        border-radius:4px;
        font-size:24px;
        color:rgba(255,126,30,1);
        line-height:36px;
      }
      .more_time{
        background:#def5ed;
        color:#16bc84;
      }
      .price{
        text-align: right;
        font-size:28px;
        color:rgba(51,51,51,1);
        line-height:40px;
      }
    }
  }
  .buy_num{
    .flex();
    justify-content: space-between;
    align-items: center;
    padding:22px 28px;
    margin-bottom:14px;
    .buy_num_left{
      font-size:28px;
      color:rgba(51,51,51,1);
    }
    .buy_num_right{
      flex:1;
      .flex();
      justify-content: flex-end;
      .reduce{
        display: block;
        width:56px;
        height:56px;
        background:rgba(238,238,238,0.3);
        border-radius:4px;
        .flex();
        justify-content: center;
        align-items: center;
        img{
          display: block;
          width:24px;
          height:4px;
        }
      }
      input{
        display: block;
        width:108px;
        height:56px;
        background:#f8f8f8;
        margin:0 10px;
        font-size:28px;
        color:rgba(51,51,51,1);
        text-align: center;
      }
      .add{
        display: block;
        width:56px;
        height:56px;
        background:rgba(238,238,238,1);
        border-radius:4px;
        .flex();
        justify-content: center;
        align-items: center;
        img{
          display: block;
          width:24px;
          height:24px;
        }
      }
    }
  }
}
.price_box{
  background:#fff;
  padding:0 28px;
  margin-bottom:120px;
  .flex();
  justify-content: space-between;
  height:88px;
  align-items: center;
  .price_left{
    font-size:28px;
    color:rgba(51,51,51,1);
  }
  .price_right{
    font-size:28px;
    color:rgba(246,67,28,1);
  }
}
// 底部按钮
.submit_bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  display: flex;
  padding:0 28px;
  box-sizing: border-box;
  background: #fff;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .submitLeft {
    display: flex;
    flex-direction: row;
    flex:1;
    .submitSumText {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
    }
    .submitNum {
      font-size: 32px;
      color: #fc3f56;
      line-height: 40px;
    }
  }
  .submit_btn {
    width: 192px;
    height: 68px;
    background-color: @color17;
    .border(@color17);
    box-sizing:border-box;
    border-radius: 4px;
    font-size: 28px;
    color: rgba(255, 255, 255, 1);
    line-height: 68px;
    text-align: center;
    margin-left:20px;
  }
  .submit_btn_primary{
    .border(#96AAF0);
    background:rgba(243,245,253,1);
    color:@color17;
  }
}


</style>